export const GROUP_LABELS: Record<string, string> = {
  stable: 'Stable',
  candidate: 'Candidate',
  dev: 'Dev'
};
